<template>
    <div>
        <div class="row mb-3">
            <div class="col-lg-4">
                <label for="">Fecha *</label>
                <v-date-picker v-model="HistorialPuesto.Fecha" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
                <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Fecha" :Mensaje="this.errorvalidacion.Fecha[0]"></Cvalidation></label>
            </div>
            <div class="col-lg-4">
                <label for="">Puesto</label>
                <input placeholder="Puesto" type="text" class="form-control" v-model="HistorialPuesto.Puesto"/>
                <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Puesto" :Mensaje="this.errorvalidacion.Puesto[0]"></Cvalidation></label>
            </div>
            <div class="col-lg-4">
                <label for="">Salario</label>
                <vue-numeric
                    class="form-control "
                    currency="$"
                    separator=","
                    placeholder="$0.00"
                    :precision="2"
                    v-model="HistorialPuesto.Salario"
                ></vue-numeric>
                <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Salario" :Mensaje="this.errorvalidacion.Salario[0]"></Cvalidation></label>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-lg-12">
                <label for="">Archivo</label>
                <div class="custom-file-input-image">
                    <input @change="SubirArchivo()" type="file" accept="application/pdf" ref="file" class="custom-file-input" id="validatedCustomFile" required>
                    <input type="text" v-model="Archivo" class="form-control">
                    <button type="button" class=""><i class="fas fa-paperclip"></i></button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <label for="">Comentario</label>
                <textarea placeholder="Comentario" class="form-control" v-model="HistorialPuesto.Comentario" cols="10" rows="10"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"HistorialPuesto",
    props:["poBtnSave"],
    data() {
        return {
            Modal:true,
            FormName:'Historial',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            HistorialPuesto:{
                IdHistorialPuesto:0,
                IdTrabajador:0,
                Fecha:'',
                Puesto:'',
                Salario:'',
                Comentario:'',
                Archivo:'',
            },
            Archivo:'Elegir Archivo (0.5MB)',
            errorvalidacion:[]
        }
    },
    methods: {
        Guardar(){
            this.errorvalidacion=[];
            let Fecha='';
            if (this.HistorialPuesto.Fecha!='' && this.HistorialPuesto.Fecha!=undefined) {
                let day=this.HistorialPuesto.Fecha.getDate();
                let month=this.HistorialPuesto.Fecha.getMonth()+1;
                let year=this.HistorialPuesto.Fecha.getFullYear();
                Fecha=year+'-'+month+'-'+day;   
            }
            let file = this.$refs.file.files[0];
            let formData=new FormData();
            formData.set('IdHistorialPuesto',this.HistorialPuesto.IdHistorialPuesto);
            formData.set('Puesto',this.HistorialPuesto.Puesto);
            formData.set('IdTrabajador',this.HistorialPuesto.IdTrabajador);
            formData.set('Comentario',this.HistorialPuesto.Comentario);
            formData.set('Fecha',Fecha);
            formData.set('Salario',this.HistorialPuesto.Salario);
            formData.set('NombreArchivo',this.HistorialPuesto.Archivo);
            formData.append('NombreArchivoFile',file);
            this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
            this.$http.post('historialpuesto/post',formData,{
                headers:{
                    'Content-Type':'multipart/form-data'
                }
            }).then((res)=>{
                this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#HistorialPuesto").modal("hide");
                this.bus.$emit('ListaPrincipal');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
        },
        Limpiar(){
            const  input  = this.$refs.file;
            input .type = 'text'
            input .type = 'file';
            this.HistorialPuesto={
                IdHistorialPuesto:0,
                IdTrabajador:0,
                Fecha:new Date(),
                Puesto:'',
                Salario:'',
                Comentario:'',
                Archivo:'',
            }
            // if (localStorage.getItem("fechacalendario")) {
			// 	let NuevaFecha = localStorage.getItem("fechacalendario");
			// 	let formatedDate = NuevaFecha.replace(/-/g, "\/");
			// 	this.HistorialPuesto.Fecha = new Date(formatedDate);
			// }
            this.Archivo='Elegir Archivo (0.5MB)';
            this.errorvalidacion=[];
        },
        Recuperar(){
            this.$http.get('historialpuesto/recovery',{
                params:{
                    IdHistorialPuesto:this.HistorialPuesto.IdHistorialPuesto
                }
            }).then((res)=>{
                const objres=res.data.data.historial;
                this.HistorialPuesto.IdHistorialPuesto=objres.IdHistorialPuesto;
                this.HistorialPuesto.Puesto=objres.Puesto;
                this.HistorialPuesto.IdTrabajador=objres.IdTrabajador;
                let formatedDate = objres.Fecha.replace(/-/g, "\/");
                this.HistorialPuesto.Fecha=new Date(formatedDate);
                this.HistorialPuesto.Salario=objres.Salario;
                this.HistorialPuesto.Archivo=objres.Archivo;
                this.HistorialPuesto.Comentario=objres.Comentario;
                this.Archivo=objres.Archivo;
            })
        },
        SubirArchivo(){
            const image = this.$refs.file.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 0.5) {
                this.$toast.info('Solo se puede subir archivos menores a 0.5 MB');
                const  input  = this.$refs.file;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extensiones permitidas .pdf');
                const  input  = this.$refs.file;
                input.type = 'text'
                input.type = 'file';
                this.Archivo='Elegir archivo (0.5MB)';
                return false;
            }

            this.Archivo=image.name;
        }
    },
    created() {
        this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdTrabajador)=>{
            this.poBtnSave.disableBtn=false;
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdTrabajador!==undefined) {
                this.HistorialPuesto.IdTrabajador=IdTrabajador;
            }
            if (Id > 0) {
				this.HistorialPuesto.IdHistorialPuesto = Id;
				this.Recuperar();
			}
        });
    },
    computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
